import { appConfig } from "@shared/utils/appConfig";
import {
  DomainGroup,
  domainGroupEnum,
  getCurrentDomainGroup,
} from "@shared/utils/domain-group";

const BRAND_OVERRIDE_COOKIE_NAME = "sidekick-brand-override";
const ONE_DAY_SECONDS = 60 * 60 * 24;

const STAGING_ROOT_DOMAIN: Record<DomainGroup, string> = {
  [domainGroupEnum.SIDEKICK]: "staging.sidekickgpt.dev",
  [domainGroupEnum.RADAR]: "staging.joinradar.ai",
};

// Netlify deploy-preview hostnames (deploy-preview-NNN.staging.*) can't be
// pre-registered in the backend's FRONTENDS config, so Origin/Host-based
// brand resolution falls back to Sidekick there. Declaring our own brand via
// this cookie (honored by the backend only outside production) fixes that
// for preview deploys — the main staging branch's own hostname is already
// pre-registered and doesn't need it, but setting it there too is harmless.
export const setBrandOverrideCookieForStaging = (): void => {
  if (appConfig.APP_ENV !== "staging") return;

  const domainGroup = getCurrentDomainGroup();
  const rootDomain = STAGING_ROOT_DOMAIN[domainGroup];

  document.cookie = [
    `${BRAND_OVERRIDE_COOKIE_NAME}=${domainGroup}`,
    `domain=.${rootDomain}`,
    "path=/",
    `max-age=${ONE_DAY_SECONDS}`,
    "SameSite=Lax",
    "Secure",
  ].join("; ");
};
